import {
  B1,
  B5,
  Icon,
  SH3,
  Stack,
  XStack,
  YStack,
  colors as zetColors,
} from '@zet/design-system'

import SelectDropDown from '../common/selectDropDown'
import UploadDocument from '../common/uploadDocument'

const DocumentUploadScreen = ({
  label = '',
  placeholder = 'Select',
  onChange,
  onBlur,
  value,
  errorMessage,
  isRequired = true,
  dropdownMode = 'single',
  isSearchable = false,
  options,
  fieldId,
  fieldDescription = '',
  selectDocument,
  config,
}) => {
  return (
    <Stack className="mx-1 mt-1">
      {!config?.rules ? (
        <>
          {/* <H5 className="px-1">Customer Income Proof</H5> */}
          <YStack className="flex-1 mt-3 justify-between">
            <XStack className="items-center space-x-2">
              <Stack className="bg-grays-20 p-1 rounded-3xl">
                <Icon
                  type="IdCardOutlined"
                  size={28}
                  color={zetColors.primary[100]}
                />
              </Stack>
              <SH3 className="text-grays-100 font-[Graphie-Bold]">
                {label}
                {isRequired ? (
                  <B1 className="text-error-100 ml-1">*</B1>
                ) : (
                  <></>
                )}
              </SH3>
            </XStack>

            <B5 className="mt-1 leading-normal mb-2">
              Please make sure the uploading file should be less than 2 MB.
            </B5>
          </YStack>
        </>
      ) : (
        <></>
      )}
      {selectDocument ? (
        <SelectDropDown
          label={''}
          placeholder={placeholder ? placeholder : 'Select'}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          errorMessage={errorMessage}
          isRequired={false}
          dropdownMode={'single'}
          isSearchable={false}
          options={options}
        />
      ) : (
        <UploadDocument
          value={value}
          errorMessage={errorMessage}
          fieldId={fieldId}
          onChange={onChange}
        />
      )}
    </Stack>
  )
}

export default DocumentUploadScreen
